import { Controller } from "@hotwired/stimulus"
import { enter, reducedMotion } from "../libs/motion"

// Going a level deeper, a drawer screen slides in from the right; going back, the screen
// above it slides in from the left. Screens on the same level (a search, a saved form) swap
// in place.
export default class extends Controller {
  slide({ target, detail }) {
    const direction = this.depth(detail.newFrame) - this.depth(target)
    if (!direction || reducedMotion()) return

    const { render } = detail
    detail.render = (current, next) => {
      render(current, next)
      for (const child of current.children) enter(child, `translateX(${direction * 16}px)`)
    }
  }

  depth(frame) {
    return Number(frame.querySelector("[data-drawer-depth]")?.dataset.drawerDepth ?? 0)
  }
}
